import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import { Formik, Form as FormikForm } from 'formik';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Modal from 'components/new_ui/Modal/Modal';
import SwitchField from 'components/new_ui/Form/SwitchField';
import { useContext } from 'components/Managers/Members/Context';

export default function Settings({ show, successCallback, cancelCallback }) {
  const { state: { finchOptions }, dispatch, actions } = useContext();

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    const params = {
      importType: values.importType ? 'automatic' : 'manual',
    };

    actions.finchUpdate(
      dispatch,
      params,
      () => {
        setSubmitting(false);
        successCallback();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show={show} size="lg">
      <h4 className="mb-4">
        Settings
      </h4>

      <Formik
        initialValues={{
          importType: finchOptions.importType === 'automatic',
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <section>
              <p>
                Please choose the Scheduled option to ensure seamless data transfer from your HRIS system.
              </p>

              <SwitchField
                id="import-type"
                name="importType"
                checkedLabel="Scheduled"
              />
            </section>

            <footer>
              <Button
                variant="outline-primary"
                onClick={() => cancelCallback()}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting && <LoadingPlaceholder placement="inline" text=" " />}
                Save
              </Button>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Settings.propTypes = {
  show: PropTypes.bool.isRequired,
  successCallback: PropTypes.func.isRequired,
  cancelCallback: PropTypes.func.isRequired,
};
